import React from 'react'
import { constants, useTranslation } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import SbciInvoiceKeys from '../../../../constants/locale/key/SbciInvoice'
import SbciInvoiceApiUrls from '../../../../apiUrls/SbciInvoiceApiUrls'
import Table from '../../../../components/aciacehighway/Table'
import CngSection from '../../../../components/cngcomponents/CngSection'
import moment from 'moment'

const {
  filter: { IN }
} = constants

function ActivityLogs(props) {
  const { invoiceId, showNotification } = props

  const { translate } = useTranslation(Namespace.SBCI_INVOICE)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    const activityLogs = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.ACTIVITY_LOGS_INFO.TITLE
    )
    const functionCode = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.ACTIVITY_LOGS_INFO.FUNCTION_CODE
    )
    const auditDescription = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.ACTIVITY_LOGS_INFO.AUDIT_DESC
    )
    const userId = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.ACTIVITY_LOGS_INFO.ACTION_USER_ID
    )
    const createdDate = translate(
      Namespace.SBCI_INVOICE,
      SbciInvoiceKeys.ACTIVITY_LOGS_INFO.DATE_TIME
    )

    return {
      activityLogs,
      functionCode,
      auditDescription,
      userId,
      createdDate
    }
  }

  const columns = [
    {
      field: 'functionCode',
      title: translatedTextsObject.functionCode
    },
    {
      field: 'auditDescription',
      title: translatedTextsObject.auditDescription
    },
    {
      field: 'userId',
      title: translatedTextsObject.userId
    },
    {
      field: 'createdDate',
      title: translatedTextsObject.createdDate,
      render: (data) =>
        data.createdDate &&
        moment(data.createdDate).format('D MMM YYYY - HH:mm')
    }
  ]

  return (
    <CngSection title={translatedTextsObject.activityLogs}>
      <Table
        columns={columns}
        compact
        fetch={{ url: SbciInvoiceApiUrls.GET_AUDIT_LOGS }}
        fetchFilters={[
          {
            field: 'keyReferenceNo',
            operator: IN,
            value: `SBCI_INVOICE_${invoiceId}`
          }
        ]}
        showNotification={showNotification}
        variant='outlined'
      />
    </CngSection>
  )
}

export default ActivityLogs
